import INotification from "@/interfaces/notification.interface";
import { NotificationsFiltersMessages } from "@/messages/notifications/notification-filters.messages";
import { NotificationsTableMessages } from "@/messages/notifications/notifications-table.messages";
import { FilterAttributes, FilterType, FilterValue, IFilter } from "@/types/filter.types";
import { SelectData } from "@/types/form.types";

import { NotificationFilterKey } from "./types";

export const NOTIFICATIONS_TABLE_COLUMNS = (messages: NotificationsTableMessages) => {
  return [
    messages.readStatusColumn,
    messages.dateTimeColumn,
    messages.detailsColumn,
    messages.optionsColumn,
  ];
};

export const NOTIFICATIONS_FILTER_OPTIONS = (
  messages: NotificationsFiltersMessages
): SelectData<NotificationFilterKey>[] => [
  { label: messages.allOption, value: "all" },
  { label: messages.readOption, value: "read" },
  { label: messages.dateTimeOption, value: "rowDate" },
  { label: messages.detailsOption, value: "detail" },
];

export const NOTIFICATIONS_FILTER_ATTRIBUTES: Partial<
  Record<NotificationFilterKey, FilterAttributes>
> = {
  all: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "disable",
  },
  read: {
    defaultValue: false,
    type: FilterType.Equals,
    valueType: "options",
  },
  rowDate: {
    defaultValue: "",
    type: FilterType.Equals,
    valueType: "date",
  },
  detail: {
    defaultValue: "",
    type: FilterType.Contains,
    valueType: "string",
  },
};

export const NOTIFICATIONS_FILTER_OPTION_VALUES = (
  messages: NotificationsFiltersMessages
): Partial<Record<NotificationFilterKey, SelectData<FilterValue>[]>> => ({
  read: [
    { value: true, label: messages.yesOption },
    { value: false, label: messages.noOption },
  ],
});

export const initialFilterValues: IFilter<INotification>[] = [
  {
    property: "read",
    value: false,
    filterType: FilterType.Equals,
  },
];
